import React, { useEffect } from 'react';
import { useReownWallet } from '../../hooks/useReownWallet';

const WalletConnect = ({ onWalletConnected, manualDisconnect }) => {
  const { address, chainId, isConnected, isConnecting, connect } = useReownWallet();

  // Handle wallet connection state changes
  useEffect(() => {
  //  if (manualDisconnect) return;

    if (isConnected && address && chainId) {
      onWalletConnected?.({ address, chainId });
    }
  }, [isConnected, address, chainId, onWalletConnected]);
  //}, [isConnected, address, chainId, onWalletConnected, manualDisconnect]);

  const handleConnect = async () => {
    try {
      await connect();
    } catch (err) {
      console.error('Connection error:', err);
    }
  };

  return (
    <div className="terminal-section" style={{ textAlign: 'center', padding: '60px 20px' }}>
      <h2 className="section-title">Ready to Pay?</h2>
      <p style={{ color: '#666', marginBottom: '30px' }}>Connect your wallet to begin.</p>
      
      <button 
        onClick={handleConnect} 
        disabled={isConnecting} 
        className="chain-button" 
        style={{ padding: '16px 32px' }}
      >
        {isConnecting ? 'Connecting...' : 'Connect Wallet'}
      </button>
    </div>
  );
};

export default WalletConnect;